// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"db273003","116":"37bf8452","337":"1215c618","432":"853c4f37","957":"4576ac6d"}[chunkId] + ".chunk.js";
};